import React, { useState, useEffect, useRef } from 'react';
import { X, Check, ChevronDown, ChevronUp, Search } from 'lucide-react';

// Filtered categories focused on residential construction
const CONSTRUCTION_CATEGORIES = [
    'General Contractors',
    'Roofing Contractors',
    'Painting Contractors',
    'Bathroom Remodeling',
    'Kitchen Planning & Remodeling Service',
    'Home Improvements',
    'Plumbers',
    'Altering & Remodeling Contractors',
    'Flooring Contractors',
    'Windows-Repair, Replacement & Installation',
    'Building Contractors',
    'Air Conditioning Contractors & Systems',
    'Siding Contractors',
    'Electricians',
    'Heating Contractors & Specialties',
    'Home Builders',
    'Building Contractors-Commercial & Industrial',
    'Windows',
    'Air Conditioning Service & Repair',
    'Home Repair & Maintenance',
    'Gutters & Downspouts',
    'Tile-Contractors & Dealers',
    'Plumbing-Drain & Sewer Cleaning',
    'Construction Consultants',
    'Doors, Frames, & Accessories',
    'Drywall Contractors',
    'Patio Builders',
    'Floor Materials',
    'Real Estate Developers',
    'Insulation Contractors',
    'Roofing Contractors-Commercial & Industrial',
    'Water Heater Repair',
    'Deck Builders',
    'Handyman Services',
    'Carpenters',
    'Concrete Contractors',
    'Sewer Cleaners & Repairers',
    'Water Heaters',
    'Plumbing Contractors-Commercial & Industrial',
    'Major Appliances',
    'Electric Companies',
    'Air Conditioning Equipment & Systems',
    'Electric Contractors-Commercial & Industrial',
    'Roofing Services Consultants',
    'Hardwood Floors',
    'Furnaces-Heating',
    'Door Repair',
    'Painting Contractors-Commercial & Industrial',
    'Sewer Contractors',
    'Cabinets',
    'Heating Equipment & Systems',
    'Masonry Contractors',
    'Heating Equipment & Systems-Repairing',
    'Building Construction Consultants',
    'Cabinet Makers',
    'Carpet & Rug Dealers',
    'Heating, Ventilating & Air Conditioning Engineers',
    'Kitchen Cabinets & Equipment-Household',
    'Plumbing, Drains & Sewer Consultants',
    'Counter Tops',
    'Building Specialties',
    'Roofing Equipment & Supplies',
    'Building Materials',
    'Basement Contractors',
    'Landscape Contractors',
    'Plate & Window Glass Repair & Replacement',
    'Fence-Sales, Service & Contractors',
    'Leak Detecting Service',
    'Foundation Contractors',
    'Heat Pumps',
    'Mechanical Contractors',
    'Professional Engineers',
    'Fire & Water Damage Restoration',
    'Water Damage Restoration',
    'Fireplaces',
    'Water Damage Emergency Service',
    'Vinyl Windows & Doors',
    'Shower Doors & Enclosures',
    'Door & Window Screens',
    'Sunrooms & Solariums',
    'Bathtubs & Sinks-Repair & Refinish',
    'Storm Windows & Doors',
    'Masonry Contractors-Commercial & Industrial',
    'Plumbing Fixtures, Parts & Supplies',
    'Siding Materials',
    'Carpet Installation',
    'Skylights',
    'Granite',
    'Kitchen Cabinets-Refinishing, Refacing & Resurfacing',
    'Wallpapers & Wallcoverings-Installation',
    'Demolition Contractors',
    'Faux Painting & Finishing',
    'Landscaping & Lawn Services',
    'Air Duct Cleaning',
    'Construction Engineers',
    'Bathroom Fixtures, Cabinets & Accessories',
    'Paint',
    'Lighting Contractors',
    'Furnace Repair & Cleaning',
    'Duct Cleaning',
    'Interior Designers & Decorators',
    'Mirrors',
    'Cleaning Contractors',
    'Gutters & Downspouts Cleaning',
    'Lighting Consultants & Designers',
    'Waterproofing Contractors',
    'Power Washing',
    'Boiler Repair & Cleaning',
    'Gas Lines-Installation & Repairing',
    'Windshield Repair',
    'Excavation Contractors',
    'Deck Cleaning & Treatment',
    'Fireplace Equipment',
    'Patio Covers & Enclosures',
    'Backflow Prevention Devices & Services',
    'Shutters',
    'Ventilating Contractors',
    'Grease Traps',
    'Lighting Fixtures',
    'Carpet & Rug Cleaners',
    'Geothermal Heating & Cooling Contractors',
    'Glass Doors',
    'Electric Equipment Repair & Service',
    'Marble-Natural',
    'Home Design & Planning',
    'Water Softening & Conditioning Equipment & Service',
    'Electric Equipment & Supplies',
    'Hardwoods',
    'Garages-Building & Repairing',
    'Garage Doors & Openers',
    'Drainage Contractors',
    'Paving Contractors',
    'Generators',
    'Sheet Metal Work',
    'Refrigeration Equipment-Commercial & Industrial',
    'Rugs',
    'Draperies, Curtains & Window Treatments',
    'Septic Tanks & Systems',
    'Tile-Cleaning, Refinishing & Sealing',
    'Shingles',
    'Landscape Designers & Consultants',
    'Generators-Electric-Service & Repair',
    'Automobile Parts & Supplies',
    'Flooring Installation Equipment & Supplies',
    'Carpet & Rug Pads, Linings & Accessories',
    'Solar Energy Equipment & Systems-Dealers',
    'Furniture Stores',
    'Duct & Duct Fittings',
    'Roof & Floor Structures',
    'Stair Builders',
    'Commercial & Industrial Flooring Contractors',
    'Garbage Disposal Repair',
    'Utility Companies',
    'Septic Tank & System Cleaning',
    'Electrical Power Systems-Maintenance',
    'Floor Waxing, Polishing & Cleaning',
    'Pumps-Service & Repair',
    'Construction Estimates',
    'Wallpapers & Wallcoverings',
    'Roof Cleaning',
    'Plastering Contractors',
    'Hardware Stores',
    'Building Restoration & Preservation',
    'Floor Materials-Wholesale & Manufacturers',
    'Lawn Maintenance',
    'Asphalt Paving & Sealcoating',
    'Building Maintenance',
    'Cabinets-Refinishing, Refacing & Resurfacing',
    'Pressure Washing Equipment & Services',
    'Heating Equipment & Systems-Wholesale',
    'Roof Decks',
    'Electronic Equipment & Supplies-Repair & Service',
    'Stucco & Exterior Coating Contractors',
    'Home Decor',
    'Electric Equipment & Supplies-Wholesale & Manufacturers',
    'Sump Pumps',
    'Stone Products',
    'House Washing',
    'Bath Equipment & Supplies',
    'Electrical Engineers',
    'Fire Alarm Systems',
    'Painters Equipment & Supplies',
    'Carpet & Rug Repair',
    'Store Fronts',
    'Major Appliance Refinishing & Repair',
    'Lighting Maintenance Service',
    'Boilers Equipment, Parts & Supplies',
    'Swimming Pool Construction',
    'Paint Removing',
    'Insulation Materials',
    'Boiler Dealers',
    'Fence Materials',
    'Wire & Cable-Electric',
    'Wall Coatings',
    'Air Quality-Indoor',
    'Solar Energy Equipment & Systems-Service & Repair',
    'Awnings & Canopies',
    'Glass-Broken',
    'Fence Repair',
    'Spray Painting & Finishing',
    'Driveway Contractors',
    'Household Fans',
    'Stone Natural',
    'Air Cleaning & Purifying Equipment',
    'Gardeners',
    'Concrete Restoration, Sealing & Cleaning',
    'Chimney Contractors',
    'Contractors Equipment & Supplies',
    'Piping Contractors',
    'Refrigerators & Freezers-Repair & Service',
    'Kitchen Accessories',
    'Closets Designing & Remodeling',
    'Fine Art Artists',
    'Glaziers',
    'Blinds-Venetian & Vertical',
    'Concrete Equipment & Supplies',
    'Energy Conservation Consultants',
    'Pumps',
    'Wood Windows',
    'Water Treatment Equipment-Service & Supplies',
    'Janitorial Service',
    'Tree Service',
    'Metal Buildings',
    'Glass Blowers',
    'Hand Painting & Decorating',
    'Door Wholesalers & Manufacturers',
    'Gazebos',
    'Water Filtration & Purification Equipment',
    'Stamped & Decorative Concrete',
    'House Cleaning',
    'Glass-Beveled, Carved, Etched, Ornamental, Etc',
    'Industrial Equipment & Supplies',
    'Ceilings-Supplies, Repair & Installation',
    'Pipe Thawing',
    'Small Appliances',
    'Lighting Systems & Equipment',
    'Security Equipment & Systems Consultants',
    'Coatings-Protective',
    'Screen Enclosures',
    'Sheet Metal Fabricators',
    'Solar Energy Equipment & Systems-Manufacturers & Distributors',
    'Construction & Building Equipment',
    'Building Materials-Wholesale & Manufacturers',
    'Landscaping Equipment & Supplies',
    'Energy Conservation Products & Services',
    'Glass-Wholesale & Manufacturers',
    'Utility Contractors',
    'Wood Products',
    'Automobile Air Conditioning Equipment',
    'Automobile Accessories',
    'Architects',
    'Window Tinting',
    'Computer Cable & Wire Installation',
    'Draperies, Curtains, Blinds & Shades Installation',
    'Swimming Pool Repair & Service',
    'Mold Remediation',
    'Irrigation Systems & Equipment',
    'Plumbing Fixtures Parts & Supplies-Wholesale & Manufacturers',
    'Tools',
    'Refrigerating Equipment-Commercial & Industrial-Servicing',
    'Lawn & Garden Equipment & Supplies',
    'Architects & Builders Services',
    'Security Control Systems & Monitoring',
    'Paint-Wholesale & Manufacturers',
    'Screens',
    'Brake Repair',
    'Kitchen Cabinets & Equipment-Wholesale & Manufacturers',
    'Metal Windows',
    'Gutter Covers',
    'Automobile Air Conditioning Equipment-Service & Repair',
    'Electric Generators',
    'Lumber',
    'Windows-Wholesale & Manufacturers',
    'Consumer Electronics',
    'Wallpaper Removing Equipment',
    'Real Estate Management',
    'Paint Manufacturing Equipment & Supplies',
    'Spraying Equipment',
    'Automobile Body Shop Equipment & Supplies',
    'Linoleum',
    'Road Building Contractors',
    'Window Cleaning',
    'Spraying Equipment-Renting',
    'Snow Removal Service',
    'Small Appliance Repair',
    'Water Pressure Cleaning',
    'Gas Companies',
    'Swimming Pool Equipment & Supplies',
    'Swimming Pool Dealers',
    'Painting-Production',
    'Tile-Wholesale & Manufacturers',
    'Concrete Products',
    'Wood Finishing',
    'Sandblasting',
    'Woodworking',
    'Garden Centers',
    'Carports',
    'Housewares',
    'Door Closers & Checks',
    'Plumbing Engineers',
    'Floors-Industrial',
    'Home Automation Systems',
    'Upholstery Cleaners',
    'Property Maintenance',
    'Glass-Automobile, Plate, Window, Etc-Manufacturers',
    'Parking Stations & Garages-Construction',
    'Smoke Detectors & Alarms',
    'Steel Erectors',
    'Real Estate Buyer Brokers',
    'Stone-Retail',
    'Glass Coating & Tinting',
    'Water Well Drilling & Pump Contractors',
    'Mechanical Engineers',
    'Storm Window & Door Repair',
    'Disaster Recovery & Relief',
    'Concrete Staining Services',
    'Retaining Walls',
    'Marble & Terrazzo Cleaning & Service',
    'Inspection Service',
    'Parking Lot Maintenance & Marking',
    'Residential Designers',
    'Sprinklers-Garden & Lawn',
    'Real Estate Inspection Service',
    'Sprinklers-Garden & Lawn, Installation & Service',
    'Pumping Contractors',
    'Gas Equipment-Service & Repair',
    'Carpet & Rug Distributors & Manufacturers',
    'Electric Motors',
    'Surge Protection Devices',
    'Auto Oil & Lube',
    'Auto Transmission',
    'Awnings & Canopies-Repair & Service',
    'Automobile Body Repairing & Painting',
    'Wood Doors',
    'Asphalt',
    'Grading Contractors',
    'Glass Furniture Tops',
    'Mobile Home Repair & Service',
    'Tire Dealers',
    'Insulation Contractors Equipment & Supplies',
    'Automobile Electric Service',
    'Roofing Equipment & Supply-Wholesale & Manufacturers',
    'Commercial & Industrial Door Sales & Repair',
    'Fans-Ventilating & Exhaust',
    'Acoustical Contractors',
    'Energy Management Engineers',
    'Paving Materials',
    'Switches-Electric',
    'Industrial Equipment Repair',
    'Building Cleaning-Exterior',
    'Table Tops',
    'Garbage Disposals',
    'Government Consultants',
    'Structural Engineers',
    'Furniture Designers & Custom Builders',
    'Millwork',
    'Board Up Service',
    'Moving Services-Labor & Materials',
    'Cabinets-Wholesale & Manufacturers',
    'Steel Processing',
    'Counter Tops-Wholesale & Manufacturers',
    'Metals',
    'Electric Switchboards',
    'Sand & Gravel',
    'Computers & Computer Equipment-Service & Repair',
    'Cultured Marble',
    'Mold Testing & Consulting',
    'Furniture Repair & Refinish',
    'Furnaces Parts & Supplies',
    'Fix-It Shops',
    'Pipe',
    'Ventilation Cleaning',
    'Pavement & Floor Marking Services',
    'Fire Protection Equipment & Supplies',
    'Concrete Breaking, Cutting & Sawing',
    'Swimming Pool Covers & Enclosures',
    'Radiators-Heating Sales, Service & Supplies',
    'Welders',
    'Electronic Equipment & Supplies-Wholesale & Manufacturers',
    'Marble-Natural-Wholesale & Manufacturers',
    'Building Designers',
    'Chimney Cleaning',
    'Swimming Pool Designing & Consulting',
    'Overhead Doors',
    'Appliance Installation',
    'Masonry Equipment & Supplies',
    'Sheet Metal Work-Manufacturers',
    'Siding Materials-Wholesale & Manufacturers',
    'Automobile Diagnostic Service',
    'Metal Doors',
    'Garage Cabinets & Organizers',
    'Aluminum',
    'Patio & Outdoor Furniture',
    'Crushed Stone',
    'Carpet & Rug Cleaning Equipment & Supplies',
    'Bamboo Products',
    'Contractors Equipment Rental',
    'Restaurant Equipment & Supplies',
    'Refrigeration Equipment-Parts & Supplies',
    'Lumber-Wholesale',
    'Humidifiers',
    'Window Shades-Equipment & Supplies',
    'Cabinetmakers-Commercial & Industrial',
    'Contractor Referral Services',
    'Parking Lots & Garages',
    'Consulting Engineers',
    'Engine Rebuilding & Exchange',
    'Caulking Contractors',
    'Gates & Accessories',
    'Building Cleaners-Interior',
    'Pumps-Renting',
    'Drilling & Boring Contractors',
    'Ready Mixed Concrete',
    'Home Theater Systems',
    'Manufacturing Engineers',
    'Mulches',
    'Scrap Metals',
    'Controls, Control Systems & Regulators',
    'Spas & Hot Tubs',
    'Propane & Natural Gas',
    'Industrial Cleaning',
    'Lead Paint Detection & Removal',
    'Real Estate Agents',
    'Pipe Inspection',
    'Metal Specialties',
    'Heating Units-Manufacturers & Distributors',
    'Stump Removal & Grinding',
    'Construction Site-Clean-Up',
    'Sewer Pipe',
    'Window Shades-Cleaning & Repairing'

].sort();

interface CategorySelectProps {
    selectedCategories: string[];
    onChange: (categories: string[]) => void;
    maxSelections?: number;
}

const CategorySelect: React.FC<CategorySelectProps> = ({
    selectedCategories,
    onChange,
    maxSelections = 5
}) => {
    const [isOpen, setIsOpen] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');
    const dropdownRef = useRef<HTMLDivElement>(null);

    const filteredCategories = CONSTRUCTION_CATEGORIES.filter(category =>
        category.toLowerCase().includes(searchTerm.toLowerCase())
    );

    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
                setIsOpen(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    const toggleCategory = (category: string) => {
        if (selectedCategories.includes(category)) {
            onChange(selectedCategories.filter(c => c !== category));
        } else if (selectedCategories.length < maxSelections) {
            onChange([...selectedCategories, category]);
        }
    };

    const removeCategory = (category: string, e: React.MouseEvent) => {
        e.stopPropagation();
        onChange(selectedCategories.filter(c => c !== category));
    };

    return (
        <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
                Select Categories
            </label>
            <div className="relative w-full" ref={dropdownRef}>
                <div
                    className="min-h-[42px] p-2 border rounded-lg bg-white cursor-pointer flex flex-wrap gap-2 items-center"
                    onClick={() => setIsOpen(!isOpen)}
                >
                    {selectedCategories.length === 0 ? (
                        <span className="text-gray-400">Select categories (max {maxSelections})</span>
                    ) : (
                        <>
                            {selectedCategories.map(category => (
                                <span
                                    key={category}
                                    className="inline-flex items-center gap-1 bg-blue-100 text-blue-800 px-2 py-1 rounded-md text-sm"
                                >
                                    {category}
                                    <X
                                        className="w-4 h-4 cursor-pointer hover:text-blue-600"
                                        onClick={(e) => removeCategory(category, e)}
                                    />
                                </span>
                            ))}
                        </>
                    )}
                    <span className="ml-auto">
                        {isOpen ? (
                            <ChevronUp className="w-5 h-5 text-gray-400" />
                        ) : (
                            <ChevronDown className="w-5 h-5 text-gray-400" />
                        )}
                    </span>
                </div>

                {isOpen && (
                    <div className="absolute z-10 w-full mt-1 bg-white border rounded-lg shadow-lg">
                        <div className="p-2 border-b">
                            <div className="relative">
                                <Search className="absolute left-2 top-2.5 w-4 h-4 text-gray-400" />
                                <input
                                    type="text"
                                    className="w-full pl-8 pr-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                                    placeholder="Search categories..."
                                    value={searchTerm}
                                    onChange={(e) => setSearchTerm(e.target.value)}
                                    onClick={(e) => e.stopPropagation()}
                                    style={{ fontSize: '16px', width: 'calc(100% - 40px)', marginLeft: '10px', paddingLeft: '10px' }}
                                />
                            </div>
                        </div>
                        <div className="max-h-60 overflow-y-auto">
                            {filteredCategories.map(category => (
                                <div
                                    key={category}
                                    className={`px-4 py-2 cursor-pointer flex items-center justify-between hover:bg-gray-100
                  ${selectedCategories.includes(category) ? 'bg-blue-50' : ''}`}
                                    onClick={() => toggleCategory(category)}
                                >
                                    <span>{category}</span>
                                    {selectedCategories.includes(category) && (
                                        <Check className="w-4 h-4 text-blue-600" />
                                    )}
                                </div>
                            ))}
                            {filteredCategories.length === 0 && (
                                <div className="px-4 py-2 text-gray-500 text-center">
                                    No categories found
                                </div>
                            )}
                        </div>
                        <div className="p-2 border-t bg-gray-50 text-sm text-gray-500">
                            Selected {selectedCategories.length} of {maxSelections} maximum
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default CategorySelect;